<template>
    <div class="flex justify-center ">
        <calendar
            :min-date="new Date()"
            :is-expanded="layout.isExpanded"
            :columns="layout.columns"
            :attributes="attrs"
            :first-day-of-week="2"
        />
    </div>
</template>
<script>
import Calendar from "v-calendar/lib/components/calendar.umd";

export default {
    name: "CalendarComponent",
    components: {
        Calendar
    },
    props: ["bookings"],
    data() {
        return {
            attrs: this.bookings
        };
    },
    computed: {
        layout() {
            return this.$screens({
                default: {
                    columns: 1,
                    isExpanded: true
                },
                md: {
                    columns: 2,
                    isExpanded: false
                },
                lg: {
                    columns: 3,
                    isExpanded: false
                },
                xl: {
                    columns: 4,
                    isExpanded: false
                }
            });
        }
    }
};
</script>
